import Descriptions from './descriptions';

export default Descriptions;
